import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy redirect that preserves the query string (App.jsx
// LegacyBehaviourRedirect kept location.search).
export const Route = createFileRoute("/_shell/behaviour")({
  beforeLoad: () => {
    throw redirect({
      to: "/behaviour-studio",
      search: (current) => current,
      replace: true,
    });
  },
});
